<script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div class="main">
    <!-- TELA DE SUCESSO -->
    <Transition>
      <TelaDeSucesso 
        v-if="telaSucesso" 
        :email="solicitacao.emailConfirm" 
      />
    </Transition>

    <div v-if="!telaSucesso" class="d-flex justify-content-around align-center m-3">
      <img src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png" height="60" />
    </div>

    <!-- TELA DE CONFIRMAÇÃO DE CÓDIGO -->
    <div v-show="isConfirmCodeEmail && !telaSucesso">
      <ConfirmEmail 
        :errosExternos="errosDeUpload" 
        :email="solicitacao.emailConfirm"
        @verification-error="handleVerificationError" 
        @verification-success="handleVerificationSuccess" 
      />
    </div>

    <!-- FORMULÁRIO PRINCIPAL -->
    <div class="container" v-show="!isConfirmCodeEmail && !telaSucesso">
      <PageHeader :title="title" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <h6 class="card-title mb-4">
                Este formulário é fundamentado legalmente pelo Art. 18 da LGPD,
                para facilitar o exercício dos seus direitos previstos na Lei
                Geral de Dados Pessoais
              </h6>
              <b-alert show dismissible variant="danger" v-if="alert.erro">
                <ul v-for="err in msg.erro" :key="err" class="mb-0">
                  <li>{{ err }}</li>
                </ul>
              </b-alert>

              <b-form @submit.prevent="onPageConfirmCodeEmail()">
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group class="mb-3" label="Tipo" label-for="lkp-tipo-solicitacao">
                      <multiselect :class="{
                          'is-invalid': $v.solicitacao.tipo.$error,
                        }" value="" v-model="tipos" :options="tipoSolicitacao" :custom-label="nameWithLang"
                        placeholder="Selecione..." track-by="name" selectLabel="" deselectLabel=""
                        id="lkp-tipo-solicitacao" @input="solicitacao.tipo = tipos ? tipos.sq_tipo : ''">
                      </multiselect>
                      <div v-if="$v.solicitacao.tipo.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.tipo.required">Selecione o tipo.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nome" label-for="input-nome-solicitacao">
                      <b-form-input v-model="solicitacao.nome" id="input-nome-solicitacao" type="text" :class="{
                          'is-invalid': $v.solicitacao.nome.$error,
                        }"></b-form-input>
                      <div v-if="$v.solicitacao.nome.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.nome.required">Preencha o nome.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="mb-3" label="CPF" label-for="input-cpf-solicitante" v-mask="'###.###.###-##'">
                      <b-form-input v-model="solicitacao.cpf" id="input-cpf-solicitante" type="text" :class="{
                          'is-invalid': $v.solicitacao.cpf.$error,
                        }"></b-form-input>
                      <div v-if="$v.solicitacao.cpf.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.cpf.required">Preencha o CPF.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="mb-3" label="E-mail" label-for="input-email-solicitante">
                      <b-form-input v-model="solicitacao.email" id="input-email-solicitante" type="email" name="email"
                        :class="{
                          'is-invalid': $v.solicitacao.email.$error,
                        }"></b-form-input>
                      <div v-if="$v.solicitacao.email.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.email.required">Preencha o E-mail.</span>
                        <span v-if="!$v.solicitacao.email.email">Preencha um E-mail valido.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="mb-3" label="Confirme o E-mail" label-for="input-email-confirm-solicitante">
                      <b-form-input v-model="solicitacao.emailConfirm" id="input-email-confirm-solicitante" type="email"
                        :class="{
                          'is-invalid': $v.solicitacao.emailConfirm.$error,
                        }" @paste.prevent @drop.prevent autocomplete="off"></b-form-input>
                      <div v-if="$v.solicitacao.emailConfirm.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.emailConfirm.required">Confirme o E-mail.</span>
                        <span v-if="!$v.solicitacao.emailConfirm.email">Confirme um E-mail valido.</span>
                        <span v-if="!$v.solicitacao.emailConfirm.sameAsEmail">Os e-mails devem ser o mesmo.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="mb-3" label="Telefone (DDD + número)"
                      label-for="input-ddd-telefone-solicitante">
                      <b-form-input v-model="dddTelefone" id="input-ddd-telefone-solicitante" v-mask="'(##) #####-####'"
                        type="text" :class="{
                          'is-invalid': $v.dddTelefone.$error,
                        }"></b-form-input>
                      <div v-if="$v.dddTelefone.$error" class="invalid-feedback">
                        <span v-if="!$v.dddTelefone.required">Preencha o telefone.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group class="mb-3" label="Especificação do pedido"
                      label-for="textarea-mensagem-solicitante">
                      <b-form-textarea id="textarea-mensagem-solicitante" v-model="solicitacao.mensagem" rows="3"
                        :class="{
                          'is-invalid': $v.solicitacao.mensagem.$error,
                        }"></b-form-textarea>
                      <div v-if="$v.solicitacao.mensagem.$error" class="invalid-feedback">
                        <span v-if="!$v.solicitacao.mensagem.required">Descreva o pedido.</span>
                      </div>
                    </b-form-group>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-lg-12">
                    <label for="dropzone" class="form-label">Arquivos
                      <span class="text-danger">
                        (Observação. Um dos anexos deverá ser uma selfie com o
                        documento pessoal).</span></label>
                    <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true" :options="dropzoneOptions"
                      @vdropzone-error="onFileError" @vdropzone-sending="sendImages"
                      @vdropzone-success="successDropZone" @vdropzone-removed-file="removedFile"
                      @vdropzone-canceled="preventCanceled" @vdropzone-queue-complete="isUploadedCompletely"
                      @vdropzone-added-file="validarArquivoAoAdicionar">
                      <div class="dropzone-custom-content">
                        <i class="display-4 text-muted bx bxs-cloud-upload"></i>
                        <h4>
                          Arraste o arquivo aqui ou clique para fazer o upload.
                        </h4>
                      </div>
                    </vue-dropzone>
                    <div v-if="isValidaImg" class="invalid-feedback d-block">
                      <span>É obrigatorio incluir imagens!</span>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="gridCheck" required="" />
                    <label class="form-check-label" for="gridCheck">
                      Declaro que sou o titular dos dados. Li e entendi os
                      termos deste Pedido de Acesso aos Dados do Titular e
                      certifico que as informações fornecidas neste formulário
                      são verdadeiras. Entendo que é necessário que a Unicampo
                      confirme a minha identidade e, para isto, pode ser
                      necessário à obtenção de informações mais detalhadas para
                      localizarem os dados pessoais corretos que estou
                      solicitando.
                    </label>
                  </div>
                </div>
                <div class="button-items">
                  <b-button size="lg" variant="primary" type="submit" v-if="!isBtnSubmited">
                    <i class="bx bx-send font-size-16 align-middle me-2"></i>
                    Enviar
                  </b-button>
                  <b-button size="lg" variant="primary" disabled v-else>
                    <b-spinner small></b-spinner>
                    Carregando...
                  </b-button>
                </div>
                <vue-recaptcha sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D" size="invisible"
                  @verify="verifyMethod" ref="recaptcha">
                </vue-recaptcha>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appConfig from "@/app.config";
import vue2Dropzone from "vue2-dropzone";
import Multiselect from "vue-multiselect";
import TelaDeSucesso from "./telaDeSucesso";
import { VueRecaptcha } from "vue-recaptcha";
import PageHeader from "@/components/page-header";
import ConfirmEmail from "@/components/lgpd/confirmEmail";
import { required, email, sameAs } from "vuelidate/lib/validators";

export default {
  layout: "empty",
  page: {
    title: "Formulário LGPD",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Multiselect,
    ConfirmEmail,
    VueRecaptcha,
    TelaDeSucesso,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      title: "Formulário Requisição de Direitos do Titular",
      tipoSolicitacao: [],
      tipos: null,
      dropzoneOptions: {
        url: null,
        maxFiles: 10,
        maxFilesize: 8,
        paramName: "file",
        parallelUploads: 1,
        thumbnailWidth: 150,
        addRemoveLinks: true,
        uploadMultiple: false,
        autoProcessQueue: false,
        acceptedFiles: '.pdf,.png,.jpg,.jpeg,.doc,.docx',
        dictInvalidFileType: "Tipo de arquivo não permitido. Use apenas PDF, PNG, JPG, JPEG, DOC ou DOCX.",
        dictFileTooBig: "Arquivo muito grande ({{filesize}}MB). Tamanho máximo: {{maxFilesize}}MB.",
        dictMaxFilesExceeded: "Você pode enviar no máximo {{maxFiles}} arquivos.",
      },
      dddTelefone: null,
      isValidaImg: false,
      solicitacao: {
        tipo: null,
        nome: null,
        cpf: null,
        email: null,
        ddd: null,
        telefone: null,
        mensagem: null,
        ipPublico: null,
        sqUsuario: null,
        emailConfirm: null,
        sqSolicitacao: null,
      },
      msg: {
        erro: [],
      },
      alert: {
        erro: false,
      },
      telaSucesso: false,
      isBtnSubmited: false,
      isConfirmCodeEmail: false,
      errosDeUpload: [] || null,
    };
  },
  created() {
    this.dropzoneOptions.url = this.$http.defaults.baseURL + "api/lgpd/upload";
    this.getTiposSolicitacao();
    this.getIp();
  },

  methods: {
    getTiposSolicitacao() {
      this.$http
        .get("api/lgpd/tipo-solicitacao")
        .then((response) => {
          this.tipoSolicitacao = response.data;
          this.alert.erro = false;
          this.msg.erro = [];
        })
        .catch((err) => {
          this.alert.erro = true;
          this.msg.erro.push(err.response.data.message);
        });
    },

    nameWithLang({ nm_tipo }) {
      return `${nm_tipo}`;
    },

    onPageConfirmCodeEmail() {
      this.$v.$touch();

      const files = this.$refs.myVueDropzone.getAcceptedFiles();
      const temArquivos = files.length > 0;

      if (!temArquivos) {
        this.isValidaImg = true;
        this.alert.erro = true;
        this.msg.erro = ["É obrigatório incluir pelo menos um arquivo."];
        return false;
      }

      const arquivosValidos = this.validarTiposDeArquivo();
      if (!arquivosValidos) {
        return false;
      }

      const tamanhoValido = this.validarTamanhoArquivos(files);
      if (!tamanhoValido) {
        return false;
      }

      if (this.$v.$invalid) {
        return false;
      }

      this.isBtnSubmited = true;
      this.alert.erro = false;
      this.msg.erro = [];

      this.splitDDDAndTelefone(this.dddTelefone);
      this.mandaEmailCodeConfirme();
    },

    mandaEmailCodeConfirme() {
      this.$http
        .put(`api/lgpd/confirme-code/${this.solicitacao.emailConfirm}`, {
          name: this.solicitacao.nome,
        })
        .then(() => {
          this.alert.erro = false;
          this.msg.erro = [];
          this.isConfirmCodeEmail = true;
        })
        .catch((err) => {
          this.alert.erro = true;
          this.msg.erro.push(err.response.data.message);
        });
    },

    onSubmit() {
      this.$http
        .post("api/lgpd/solicitacao", this.solicitacao)
        .then((response) => {
          this.alert.erro = false;

          this.solicitacao.sqSolicitacao = response.data.p_sq_solicitacao;
          this.solicitacao.sqUsuario = response.data.p_sq_usuario;

          if (this.solicitacao.sqSolicitacao) {
            this.enviaArquivo();
          }
        })
        .catch((err) => {
          this.isConfirmCodeEmail = false;
          this.isBtnSubmited = false;
          this.alert.erro = true;

          this.msg.erro.push(err.response.data.message);
          this.msg.erro.push(
            err.response.data.errors.tipo
              ? err.response.data.errors.tipo[0]
              : ""
          );
          this.msg.erro.push(
            err.response.data.errors.nome
              ? err.response.data.errors.nome[0]
              : ""
          );
          this.msg.erro.push(
            err.response.data.errors.cpf ? err.response.data.errors.cpf[0] : ""
          );
          this.msg.erro.push(
            err.response.data.errors.email
              ? err.response.data.errors.email[0]
              : ""
          );
        });
    },

    splitDDDAndTelefone(dddTelefone) {
      this.solicitacao.ddd = dddTelefone.split(" ")[0].replace(/[^\d]+/g, "");
      this.solicitacao.telefone = dddTelefone.split(" ")[1].replace("-", "");
    },

    getIp() {
      fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
          .then(({ ip }) => {
            this.solicitacao.ipPublico = ip;
        })
        .catch((error) => {
          console.error('Erro ao obter IP:', error);
          this.solicitacao.ipPublico = 'IP não disponível';
      });
    },

    enviaArquivo() {
      const dropzone = this.$refs.myVueDropzone;
      const files = dropzone.getAcceptedFiles();

      if (files.length === 0) {
        this.isValidaImg = true;
        return false;
      }

      const formData = new FormData();
      files.forEach((file) => {
        formData.append('file[]', file);
      });

      formData.append('sqSolicitacao', this.solicitacao.sqSolicitacao);
      formData.append('sqUsuario', this.solicitacao.sqUsuario);

      this.$http.post('api/lgpd/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then(response => {
        this.telaSucesso = true;
      })
      .catch(error => {
        console.error('Erro:', error.response?.data);
        if (error.response?.data?.errors) {
          this.errosDeUpload = error.response.data.errors;
        } else if (typeof error.response?.data === 'string') {
          this.errosDeUpload = [error.response.data];
        } else {
          this.errosDeUpload = ['Erro desconhecido ao fazer upload.'];
        }
      });
    },

    isUploadedCompletely: function () {
      this.$router.push("/lgpd");
    },

    isValidateInputImage(qtsImgs) {
      if (qtsImgs <= 0) {
        this.isValidaImg = true;
        return true;
      }
      this.isValidaImg = false;
      return false;
    },

    removedFile() {},
    successDropZone() {},
    preventCanceled() {
      return false;
    },
    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then((response) => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    validarTiposDeArquivo() {
      const files = this.$refs.myVueDropzone.getAcceptedFiles();
      const arquivosInvalidos = [];

      for (const file of files) {
        const tipo = file.type.toLowerCase();
        const nome = file.name;
        const extensao = nome.split('.').pop().toLowerCase();

        const tiposPermitidos = [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ];

        const extensoesPermitidas = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx'];

        const tipoValido = tiposPermitidos.includes(tipo);
        const extensaoValida = extensoesPermitidas.includes(extensao);

        if (!tipoValido || !extensaoValida) {
          arquivosInvalidos.push(nome);
        }
      }

      if (arquivosInvalidos.length > 0) {
        this.alert.erro = true;
        this.msg.erro = [
          `Os seguintes arquivos não são permitidos: ${arquivosInvalidos.join(', ')}.`,
          "Formatos aceitos: JPG, PNG, GIF, WEBP, PDF, DOC, DOCX."
        ];
        return false;
      }
      return true;
    },

    validarArquivoAoAdicionar(file) {
      const tipo = file.type.toLowerCase();
      const nome = file.name;
      const extensao = nome.split('.').pop().toLowerCase();

      const tiposPermitidos = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
      ];

      const extensoesPermitidas = ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx'];

      const tipoValido = tiposPermitidos.includes(tipo);
      const extensaoValida = extensoesPermitidas.includes(extensao);

      if (!tipoValido || !extensaoValida) {
        this.$refs.myVueDropzone.removeFile(file);
        this.alert.erro = true;
        this.msg.erro = [`O arquivo "${nome}" não é permitido. Formatos aceitos: PDF, PNG, JPG, JPEG, DOC, DOCX.`];

        // Limpa a mensagem após 5 segundos
        setTimeout(() => {
          this.alert.erro = false;
          this.msg.erro = [];
        }, 5000);

        return false;
      }

      this.alert.erro = false;
      this.msg.erro = [];
      return true;
    },

    validarTamanhoArquivos(files) {
      const tamanhoMaximo = 8 * 1024 * 1024; // 8MB em bytes
      const arquivosGrandes = [];

      for (const file of files) {
        if (file.size > tamanhoMaximo) {
          arquivosGrandes.push(file.name);
        }
      }

      if (arquivosGrandes.length > 0) {
        this.alert.erro = true;
        this.msg.erro = [
          `Os seguintes arquivos excedem o tamanho máximo de 8MB: ${arquivosGrandes.join(', ')}.`
        ];
        return false;
      }
      return true;
    },

    onFileError(file, message) {
      console.error("Erro no upload:", message);
      this.alert.erro = true;

      if (message.includes("File is too big")) {
        this.msg.erro = ["Arquivo muito grande. Tamanho máximo: 8MB."];
      } else if (message.includes("You can't upload files of this type")) {
        this.msg.erro = ["Tipo de arquivo não permitido."];
      } else {
        this.msg.erro = ["Erro ao processar o arquivo. Tente novamente."];
      }
      this.$refs.myVueDropzone.removeFile(file);
    },

    sendImages(file, xhr, formData) {
      formData.append('sqSolicitacao', this.solicitacao.sqSolicitacao);
      formData.append('sqUsuario', this.solicitacao.sqUsuario);
    },

      handleVerificationSuccess() {
        this.onSubmit();
      },
      
      handleVerificationError(error) {
      console.error('Erro na verificação:', error);
        this.alert.erro = true;
        this.msg.erro = ['Erro na verificação do código.'];
      },
  },

  validations: {
    solicitacao: {
      tipo: { required },
      nome: { required },
      cpf: { required },
      mensagem: { required },
      email: { required, email },
      emailConfirm: { required, email, sameAsEmail: sameAs("email") },
    },
    dddTelefone: { required },
  },
};
</script>

<style>
.is-valid .multiselect__tags {
  border-color: #34c38f !important;
}
.is-invalid .multiselect__tags {
  border-color: #f46a6a !important;
}

.is-valid .mx-input {
  border-color: #34c38f !important;
}

.is-invalid .mx-input {
  border-color: #f46a6a !important;
}

.dropzone .dz-preview.dz-error .dz-error-message {
  display: block;
  opacity: 1;
}

.invalid-dropzone {
  border: 2px dashed #f46a6a !important;
}

.valid-dropzone {
  border: 2px dashed #34c38f !important;
}

.dropzone-error {
  color: #f46a6a;
  font-size: 14px;
  margin-top: 5px;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
